import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import VM from 'scratch-vm';
import { injectIntl, intlShape } from 'react-intl';

import ErrorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import {
    getIsError,
    getIsShowingProject
} from '../reducers/project-state';
import {
    activateTab,
    BLOCKS_TAB_INDEX,
    COSTUMES_TAB_INDEX,
    SOUNDS_TAB_INDEX
} from '../reducers/editor-tab';

import {
    closeCostumeLibrary,
    closeBackdropLibrary,
    closeTelemetryModal,
    openExtensionLibrary,
    closeCaseResource,
    closeBrainScience,
    openBrainScience,
    updateBrainScience,
    openChartDataModal,
    closeChartDataModal,

    openHandpySimModal,
    closeHandpySimModal,
    updateHandpyScreenLine1,
    updateHandpyScreenLine2,
    updateHandpyScreenLine3,
    updateHandpyScreenLine4,
    updateHandpyScreenShow,
    // handpyBoardButtonAction

    openHandpyWebsiteModal,
    closeHandpyWebsiteModal,
    openHandpyMobileBtnModal,
    closeHandpyMobileBtnModal,
    openHandpyMobileMsgModal,
    closeHandpyMobileMsgModal,
    updateHandpySiotTopic,
    updateHandpySiotTopicData,
    updateHandpyMobileModalBleName,
    updateHandpyMobileModalBleMsg

} from '../reducers/modals';
import {showAlertWithAixiong, closeAlertWithId} from '../reducers/alerts';
// zswl
import {showCode, sendChartData} from '../reducers/code';

import FontLoaderHOC from '../lib/font-loader-hoc.jsx';
import LocalizationHOC from '../lib/localization-hoc.jsx';
import ProjectFetcherHOC from '../lib/project-fetcher-hoc.jsx';
import TitledHOC from '../lib/titled-hoc.jsx';
import ProjectSaverHOC from '../lib/project-saver-hoc.jsx';
import QueryParserHOC from '../lib/query-parser-hoc.jsx';
import storage from '../lib/storage';
import vmListenerHOC from '../lib/vm-listener-hoc.jsx';
import vmManagerHOC from '../lib/vm-manager-hoc.jsx';
import cloudManagerHOC from '../lib/cloud-manager-hoc.jsx';
import bindAll from 'lodash.bindall';
import GUIComponent from '../components/gui/gui.jsx';
import { setIsScratchDesktop } from '../lib/isScratchDesktop.js';

Date.prototype.Format = function (fmt) {
    let o = {
        'M+': this.getMonth() + 1, // 月份
        'd+': this.getDate(), // 日
        'h+': this.getHours(), // 小时
        'm+': this.getMinutes(), // 分
        's+': this.getSeconds(), // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
        'S': this.getMilliseconds(), // 毫秒
    }
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
}

class GUI extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleDataVisualization',
            'handleHandpySimulator'
        ]);
    }
    componentWillMount () {
        let _search = location.search;
        location._query = {};
        location._query['lang'] = 'en';
        let queryArray = [];
        if (_search) {
            _search = _search.replace('?', '');
            queryArray = _search.split('&');
            for (var i = 0; i < queryArray.length; i++) {
                location._query[queryArray[i].split('=')[0]] = queryArray[i].split('=')[1];
            }
        }
    }
    componentDidMount () {
        setIsScratchDesktop(this.props.isScratchDesktop);
        this.props.onStorageInit(storage);
        this.props.onVmInit(this.props.vm);

        let self = this

        let accessToken = location._query['accessToken']
        let url = location._query['url']

        if (url) {
            // 获取远程sb3文件二进制流
            let xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (this.status == 200) {
                    let blob = this.response;
                    // 将Blob对象转换成 ArrayBuffer
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    reader.onload = function (e) {
                        setTimeout(function () {
                            self.props.vm.loadProject(reader.result)
                        }, 1000)
                    }
                }
            }
            xhr.send();
        }

        if (!this.props.vm._events.DATA_VISUALIZATION) {
            this.props.vm.on('DATA_VISUALIZATION', this.handleDataVisualization);
        }
        if (!this.props.vm._events.HANDPY_VIRTUAL) {
            this.props.vm.on('HANDPY_VIRTUAL', this.handleHandpySimulator);
        }
        
    }
    componentDidUpdate (prevProps) {
        if (this.props.projectId !== prevProps.projectId && this.props.projectId !== null) {
            this.props.onUpdateProjectId(this.props.projectId);
        }
        if (this.props.isShowingProject && !prevProps.isShowingProject) {
            // this only notifies container when a project changes from not yet loaded to loaded
            // At this time the project view in www doesn't need to know when a project is unloaded
            this.props.onProjectLoaded();
        }
    }

    handleDataVisualization (arg) {
        const { type, brainScienceData } = arg;
        // console.log("handleDataVisualization ...arg...", arg)
        switch (type) {
        case 'showChartWindow':
            this.props.showBrainScienceModal(brainScienceData);
            break;
        case 'updateChartWindow':
            this.props.updateBrainScienceModal(brainScienceData);
            break;
        case 'openChartWindow':
            this.props.showChartDataModal();
            break;
        case 'closeChartWindow':
            this.props.onRequestCloseModalComponent();
            break;
        default:
            this.props.sendChartData({ ...arg })
        }
    }

    handleHandpySimulator (arg) {
        const {type} = arg;
        // console.log('handleHandpySimulator arg', arg)
        switch (type) {
        case 'openHandpyModal':
            this.props.showHandpySimModal();
            break;
        case 'closeHandpyModal':
            this.props.hideHandpySimModal();
            break;
        case 'oledDisplayByLine1':
            this.props.updateHandpyScreenLine1(arg.data);
            break;
        case 'oledDisplayByLine2':
            this.props.updateHandpyScreenLine2(arg.data);
            break;
        case 'oledDisplayByLine3':
            this.props.updateHandpyScreenLine3(arg.data);
            break;
        case 'oledDisplayByLine4':
            this.props.updateHandpyScreenLine4(arg.data);
            break;
        case 'oledDisplayShow':
            this.props.updateHandpyScreenShow(arg.data);
            break;
        case 'openHandpyWebsiteModal':
            this.props.openHandpyWebsiteModal();
            break;
        case 'closeHandpyWebsiteModal':
            this.props.closeHandpyWebsiteModal();
            break;

        case 'openHandpyMobileBtnModal':
            this.props.openHandpyMobileBtnModal();
            break;
        case 'closeHandpyMobileBtnModal':
            this.props.closeHandpyMobileBtnModal();
            break;
        case 'openHandpyMobileMsgModal':
            this.props.openHandpyMobileMsgModal();
            break;
        case 'closeHandpyMobileMsgModal':
            this.props.closeHandpyMobileMsgModal();
            break;

        case 'updateHandpyMobileModalBleName':
            this.props.updateHandpyMobileModalBleName(arg.data);
            break;
        case 'updateHandpyMobileModalBleMsg':
            this.props.updateHandpyMobileModalBleMsg(arg.data);
            break;

        case 'subscribeSIot':
            this.props.updateHandpySiotTopic(arg.data);
            break;
        case 'publishSIoT':
            this.props.updateHandpySiotTopicData(arg.data);
            break;
        
        case 'showAlertWithAixiong':
            this.props.showAlertWithAixiong(arg.data);
            break;
        case 'closeAlertWithId':
            this.props.closeAlertWithId(arg.data);
            break;

        default:
            this.props.hideHandpySimModal();
        }
    }

    render () {
        if (this.props.isError) {
            throw new Error(
                `Error in Scratch GUI [location=${window.location}]: ${this.props.error}`);
        }
        const {
            /* eslint-disable no-unused-vars */
            assetHost,
            cloudHost,
            error,
            isError,
            isScratchDesktop,
            isShowingProject,
            onProjectLoaded,
            onStorageInit,
            onUpdateProjectId,
            onVmInit,
            showCode,
            projectHost,
            projectId,
            /* eslint-enable no-unused-vars */
            children,
            fetchingProject,
            isLoading,
            loadingStateVisible,

            ...componentProps
        } = this.props;

        return (
            <GUIComponent
                loading={fetchingProject || isLoading || loadingStateVisible}
                {...componentProps}
            >
                {children}
            </GUIComponent>
        );
    }
}

GUI.propTypes = {
    showCode: PropTypes.func,
    assetHost: PropTypes.string,
    children: PropTypes.node,
    cloudHost: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    fetchingProject: PropTypes.bool,
    intl: intlShape,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isScratchDesktop: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    loadingStateVisible: PropTypes.bool,
    onProjectLoaded: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onStorageInit: PropTypes.func,
    onUpdateProjectId: PropTypes.func,
    onVmInit: PropTypes.func,
    projectHost: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    telemetryModalVisible: PropTypes.bool,

    showHandpySimModal: PropTypes.func,
    hideHandpySimModal: PropTypes.func,
    updateHandpyScreenLine1: PropTypes.func,
    updateHandpyScreenLine2: PropTypes.func,
    updateHandpyScreenLine3: PropTypes.func,
    updateHandpyScreenLine4: PropTypes.func,
    updateHandpyScreenShow: PropTypes.func,
    // handpyBoardButtonAction: PropTypes.func,
    openHandpyWebsiteModal: PropTypes.func,
    closeHandpyWebsiteModal: PropTypes.func,
    openHandpyMobileBtnModal: PropTypes.func,
    closeHandpyMobileBtnModal: PropTypes.func,
    openHandpyMobileMsgModal: PropTypes.func,
    closeHandpyMobileMsgModal: PropTypes.func,
    updateHandpySiotTopic: PropTypes.func,
    updateHandpySiotTopicData: PropTypes.func,
    updateHandpyMobileModalBleName: PropTypes.func,
    updateHandpyMobileModalBleMsg: PropTypes.func,
    showAlertWithAixiong: PropTypes.func,
    closeAlertWithId: PropTypes.func,

    vm: PropTypes.instanceOf(VM).isRequired
};

GUI.defaultProps = {
    isScratchDesktop: false,
    onStorageInit: storageInstance => storageInstance.addOfficialScratchWebStores(),
    onProjectLoaded: () => { },
    onUpdateProjectId: () => { },
    onVmInit: (/* vm */) => { }
};

const mapStateToProps = state => {

    const loadingState = state.scratchGui.projectState.loadingState;
    return {
        activeTabIndex: state.scratchGui.editorTab.activeTabIndex,
        alertsVisible: state.scratchGui.alerts.visible,
        backdropLibraryVisible: state.scratchGui.modals.backdropLibrary,
        blocksTabVisible: state.scratchGui.editorTab.activeTabIndex === BLOCKS_TAB_INDEX,
        cardsVisible: state.scratchGui.cards.visible,
        connectionModalVisible: state.scratchGui.modals.connectionModal,
        costumeLibraryVisible: state.scratchGui.modals.costumeLibrary,
        costumesTabVisible: state.scratchGui.editorTab.activeTabIndex === COSTUMES_TAB_INDEX,
        error: state.scratchGui.projectState.error,
        isError: getIsError(loadingState),
        isFullScreen: state.scratchGui.mode.isFullScreen,
        isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
        // zswl
        runMode: state.scratchGui.mode.runMode,
        code: state.scratchGui.code.code,
        burnResult: state.scratchGui.code.burnResult,
        chartData: state.scratchGui.code.chartData,
        caseResourceLibraryVisible: state.scratchGui.modals.caseResourceLibrary,
        brainScienceModalVisible: state.scratchGui.modals.brainScience,
        brainScienceData: state.scratchGui.modals.brainScienceData,
        chartDataModalVisible: state.scratchGui.modals.chartDataModal,

        handpySimulatorModalVisible: state.scratchGui.modals.handpySimModal,
        handpyWebsiteModalVisible: state.scratchGui.modals.HANDPY_WEBSITE_MODAL,
        handpyMobileBtnModalVisible: state.scratchGui.modals.HANDPY_MOBILE_BTN_MODAL,
        handpyMobileMsgModalVisible: state.scratchGui.modals.HANDPY_MOBILE_MSG_MODAL,

        // zswl
        isRtl: state.locales.isRtl,
        isShowingProject: getIsShowingProject(loadingState),
        loadingStateVisible: state.scratchGui.modals.loadingProject,
        projectId: state.scratchGui.projectState.projectId,
        soundsTabVisible: state.scratchGui.editorTab.activeTabIndex === SOUNDS_TAB_INDEX,
        targetIsStage: (
            state.scratchGui.targets.stage &&
            state.scratchGui.targets.stage.id === state.scratchGui.targets.editingTarget
        ),
        telemetryModalVisible: state.scratchGui.modals.telemetryModal,
        tipsLibraryVisible: state.scratchGui.modals.tipsLibrary,
        vm: state.scratchGui.vm
    };
};

const mapDispatchToProps = dispatch => ({
    onExtensionButtonClick: () => dispatch(openExtensionLibrary()),
    onActivateTab: tab => dispatch(activateTab(tab)),
    onActivateCostumesTab: () => dispatch(activateTab(COSTUMES_TAB_INDEX)),
    onActivateSoundsTab: () => dispatch(activateTab(SOUNDS_TAB_INDEX)),
    onRequestCloseBackdropLibrary: () => dispatch(closeBackdropLibrary()),
    onRequestCloseCostumeLibrary: () => dispatch(closeCostumeLibrary()),
    onRequestCloseTelemetryModal: () => dispatch(closeTelemetryModal()),
    // zswl
    showCode: code => dispatch(showCode(code)),
    onRequestCloseCaseResourceLibrary: () => dispatch(closeCaseResource()),
    onRequestCloseBrainScienceModal: () => dispatch(closeBrainScience()),
    showBrainScienceModal: data => dispatch(openBrainScience(data)),
    showChartDataModal: data => dispatch(openChartDataModal(data)),
    onRequestCloseModalComponent: () => dispatch(closeChartDataModal()),
    updateBrainScienceModal: data => dispatch(updateBrainScience(data)),
    sendChartData: block => dispatch(sendChartData(block)),

    showHandpySimModal: () => dispatch(openHandpySimModal()),
    hideHandpySimModal: () => dispatch(closeHandpySimModal()),
    updateHandpyScreenLine1: data => dispatch(updateHandpyScreenLine1(data)),
    updateHandpyScreenLine2: data => dispatch(updateHandpyScreenLine2(data)),
    updateHandpyScreenLine3: data => dispatch(updateHandpyScreenLine3(data)),
    updateHandpyScreenLine4: data => dispatch(updateHandpyScreenLine4(data)),
    updateHandpyScreenShow: data => dispatch(updateHandpyScreenShow(data)),
    // handpyBoardButtonAction: data => dispatch(handpyBoardButtonAction(data))

    openHandpyWebsiteModal: () => dispatch(openHandpyWebsiteModal()),
    closeHandpyWebsiteModal: () => dispatch(closeHandpyWebsiteModal()),
    openHandpyMobileBtnModal: () => dispatch(openHandpyMobileBtnModal()),
    closeHandpyMobileBtnModal: () => dispatch(closeHandpyMobileBtnModal()),
    openHandpyMobileMsgModal: () => dispatch(openHandpyMobileMsgModal()),
    closeHandpyMobileMsgModal: () => dispatch(closeHandpyMobileMsgModal()),
    updateHandpySiotTopic: data => dispatch(updateHandpySiotTopic(data)),
    updateHandpySiotTopicData: data => dispatch(updateHandpySiotTopicData(data)),
    updateHandpyMobileModalBleName: data => dispatch(updateHandpyMobileModalBleName(data)),
    updateHandpyMobileModalBleMsg: data => dispatch(updateHandpyMobileModalBleMsg(data)),

    showAlertWithAixiong: data => showAlertWithAixiong(dispatch, data),
    closeAlertWithId: data => dispatch(closeAlertWithId('aixiongInfo'))
});

const ConnectedGUI = injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps,
)(GUI));

// note that redux's 'compose' function is just being used as a general utility to make
// the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
// ability to compose reducers.
const WrappedGui = compose(
    LocalizationHOC,
    ErrorBoundaryHOC('Top Level App'),
    FontLoaderHOC,
    QueryParserHOC,
    ProjectFetcherHOC,
    TitledHOC,
    ProjectSaverHOC,
    vmListenerHOC,
    vmManagerHOC,
    cloudManagerHOC
)(ConnectedGUI);

WrappedGui.setAppElement = ReactModal.setAppElement;
export default WrappedGui;
